import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CompulsorySchoolSection from './SectionTypes/CompulsorySchoolSection';
import PreSchoolSection from './SectionTypes/PreSchoolSection';
import UpperSecondarySchoolSection from './SectionTypes/UpperSecondarySchoolSection';
import { getGuardianStudentGroup } from 'actions/sections';
import { setPageTitle } from 'actions/header';
import { PRESCHOOL, COMPULSORY_SCHOOL, UPPER_SECONDARY_EDUCATION, ADULT_EDUCATION } from 'constants/schoolTypes';
import { Spinner } from 'UI';
var SectionWrapper = /*#__PURE__*/function (_Component) {
  function SectionWrapper(props) {
    var _this;
    _classCallCheck(this, SectionWrapper);
    _this = _callSuper(this, SectionWrapper, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var groupId = _this.props.match.params.groupId;
      var activeStudent = _this.props.activeStudent;
      _this.props.getGuardianStudentGroup(activeStudent.id, groupId).then(function () {
        _this.props.setPageTitle(_this.props.group.title);
        _this.setState({
          loading: false
        });
      });
    });
    _this.state = {
      modalIsOpen: false,
      loading: true
    };
    return _this;
  }
  _inherits(SectionWrapper, _Component);
  return _createClass(SectionWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.group == null || this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      } else {
        if (this.props.activeStudent != null) {
          var school = this.props.activeStudent.schools.find(function (school) {
            return school.id == _this2.props.group.schoolID;
          });
          if (school == null) {
            return /*#__PURE__*/React.createElement("div", null);
          }
          switch (school.type) {
            case PRESCHOOL:
              return /*#__PURE__*/React.createElement(PreSchoolSection, null);
              break;
            case COMPULSORY_SCHOOL:
              return /*#__PURE__*/React.createElement(CompulsorySchoolSection, null);
              break;
            case UPPER_SECONDARY_EDUCATION:
              return /*#__PURE__*/React.createElement(UpperSecondarySchoolSection, null);
              break;
            case ADULT_EDUCATION:
              return /*#__PURE__*/React.createElement(CompulsorySchoolSection, null);
              break;
            default:
              return /*#__PURE__*/React.createElement("div", null);
              break;
          }
        }
      }
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    group: state.groups.activeGroup
  };
}
export default connect(mapStateToProps, {
  getGuardianStudentGroup: getGuardianStudentGroup,
  setPageTitle: setPageTitle
})(SectionWrapper);